/* eslint-disable no-unused-vars */
// 技术领先性
export enum ETechnologyLeadership {
    LEADING = 1, // 领先
    EQUAL = 2, // 先进
    TRAIL = 3, //追赶
    HOME_LEADING = 4 // 国内领先
}

// 定义技术贡献枚举
export enum ETechnologyContribution {
    INNOVATION = 1, //创新卖点
    KEY = 2, // 主要卖点
    SECONDARY = 3, // 次要卖点
    BASIC = 4 // 基础技术
}

// 定义技术类型枚举
export enum ECoreTechnology {
    CORE = 0, // 核心技术
    KEY = 1, // 关键技术
    BASIC = 2, // 基础技术
    RESERVE = 3, //储备技术
    INVALID = -1 // 错误情况
}



// 0 不参与评审 1 参与评审 2 旁听
export const EParticipate = {
    NO_PARTICIPATE: null,
    PARTICIPATE: true,
    AUDIT: false,
}

export const EJudgesType = {
    NULL: null,
    REVIEWER: 1, // 评审员
    AUDITOR: 2, // 旁听
}

